import momentGenerateConfig from "rc-picker/es/generate/moment";
import generatePicker from './generatePicker';
var DatePicker = generatePicker(momentGenerateConfig);
export default DatePicker;